<template>
  <no-auth-layout>
    <div class="pass-reset-page" v-if="!data.success">
      <h2 class="card-title center-align">Ustaw nowe hasło</h2>
      <p class="card-subtitle center-align">
        Wpisz w poniższym polu nowe hasło,<br>
        którym chcesz się logować do Twojego panelu.
      </p>

      <div class="email-auth-container">
        <div class="line-through-header center-align">
          <span>Twoje nowe hasło:</span>
        </div>

        <form @submit.prevent="submit()">
          <div v-if="data.errors" class="center-align validation-errors">
            <span class="red-text" v-if="data.errors['message']">{{ data.errors['message'].join(', ') }}</span>
            <span class="red-text" v-else>Wystąpił nieoczekiwany błąd aplikacji</span>
          </div>

          <input-field type="password" name="password"
            label="Nowe hasło" v-model="data.password"
            @updateError="val => data.errors['password'] = val"
            required="true" :errors="data.errors['password']"/>
          <input-field type="password" name="password_confirmation"
            label="Powtórz hasło" v-model="data.password_confirmation"
            @updateError="val => data.errors['password_confirmation'] = val"
            required="true" :errors="data.errors['password_confirmation']"/>

          <button class="btn-large z-depth-0" type="submit">Zapisz nowe hasło</button>
        </form>
      </div>
      <br>
      <div class="card-footer">
        Jeśli nadal potrzebujesz pomocy,<br/>
        wyślij email na <a href="mailto:partnerzy@punkta.pl"> partnerzy@punkta.pl </a>
      </div>
      <Loader :loading="data.loading"/>
    </div>
  </no-auth-layout>
</template>

<script>
import NoAuthLayout from '@/layouts/noAuthLayout'
import InputField from '@/components/inputs/text'
import Loader from '@/components/loader'
export default {
  name: 'passReset',
  components: { NoAuthLayout, InputField, Loader },
  data () {
    return {
      data: {
        loading: false,
        password: '',
        password_confirmation: '',
        errors: false
      }
    }
  },
  methods: {
    submit () {
      this.data.loading = true
      this.$store.dispatch('passReset', {
        user: {
          reset_password_token: this.$route.query.reset_password_token,
          password: this.data.password,
          password_confirmation: this.data.password_confirmation
        }
      })
      .then(
        response => {
          this.data.loading = false
          if (response.code === 200) {
            this.$router.push({ name: 'login' })
          }
        },
        errorResponse => {
          this.data.loading = false
          this.data.errors = errorResponse.errors
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// passReset.vue?43d0070e